import { AssetDto, AssetVideoTypeDataDto, GalleryCover, GalleryTeaser } from '@picflow/types';

const calcUuid = (asset: AssetDto) => {
  if (asset.type === 'image') return asset.version_data.uuid;
  if (asset.type === 'video') {
    const url = (asset.version_data.data as AssetVideoTypeDataDto).poster_url;
    return url.split('/base/')[0].split('images/')[1];
  }
  // if (asset.type === 'video') return `${asset.version_data.uuid}|${asset.version_data.asset_name}`;
};

export const changeCoverAsset = (cover: GalleryCover | GalleryTeaser, asset: AssetDto) => {
  cover.uuid = calcUuid(asset);
  cover.width = asset.version_data.data.width;
  cover.height = asset.version_data.data.height;
  cover.format = asset.version_data.format;
  cover.ext = asset.version_data.ext;
  const isCover = 'content_position' in cover;

  if (isCover && asset.type === 'video') {
    const duration = (asset.version_data.data as AssetVideoTypeDataDto).duration;
    cover.video_origin = `${asset.version_data.asset_name}?duration=${duration}&uuid=${asset.version_data.uuid}`;
  }
};
